import { render, staticRenderFns } from "./ChecklistMobile.vue?vue&type=template&id=ac94d1b4&"
import script from "./ChecklistMobile.vue?vue&type=script&lang=js&"
export * from "./ChecklistMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage})
